module.exports = __webpack_public_path__ + "img/portal-cloud.1172632b.svg";